import { render, staticRenderFns } from "./PlatonTable.vue?vue&type=template&id=1a04507e"
import script from "./PlatonTable.vue?vue&type=script&lang=js"
export * from "./PlatonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports